module.exports = __webpack_public_path__ + "img/pic_tomy.3c454b1d.gif";